import APIStatusChart from "./apiStatusChart";
import StatusHook from "/app/src/components/status/statusHook";
import Box from "/app/src/components/generic/components/box";
import { useTranslation } from "react-i18next";

/**
 * Displays the API status using a chart based on connection counts.
 *
 * @returns {JSX.Element} A component that renders the API status chart.
 */
export default function ApiStatus() {
  const { apiConnectionCounts } = StatusHook();
  const { t } = useTranslation();

  return (
    <Box className="w-full max-w-full">
      <h2 className="font-archivo text-neutral-charcoal text-[18px]">
        {t("translation:api_status")}
      </h2>
      <hr className="pb-[24px]" />
      <APIStatusChart data={apiConnectionCounts} />
    </Box>
  );
}
